module.exports = __webpack_public_path__ + "files/1215947c8d31d03fc84147cfd9b53283.png";